export const SuccessMessage = {
  login: 'loggedInSuccess',
  logout: 'loggedOutSuccess',
  changePassword: 'passwordUpdateSuccess',
  playerStatusUpdate: 'updatePlayerStatusSuccess',
  createOperator: 'operatorUserCreatedSuccess',
  resetPassword: 'resetPasswordSuccess',
  operatorDelete: 'operatorDeletedSuccess',
  operatorStatusUpdate: 'operatorStatusUpdateSuccess',
  resetPasswordSuccessfully: 'resetPasswordSuccessfully',
  resetPasswordLinkGenerated: 'resetPasswordLinkGeneratedSuccessfully',
  adminDetailsUpdated: 'adminDetailsUpdated',
  twoFactorEnabledSuccessfully: 'twoFactorEnabledSuccessfully',
  twoFactorDisabledSuccessfully: 'twoFactorDisabledSuccessfully'
}

export const ErrorMessage = {
  internalServerError: 'internalServerError',
  unAuthorized: 'unAuthorized'
}

export const errorCodeToMessage = new Map([
  [600, 'internalServerError'],
  [601, 'loginFailedError'],
  [602, 'invalidCredentialsError'],
  [603, 'invalidTokenError'],
  [604, 'invalidSessionError'],
  [605, 'invalidAccessError'],
  [606, 'nonOperationalError'],
  [2001, 'createUserError'],
  [2002, 'operatorNotExistsError'],
  [2003, 'operatorPlayerNotExists'],
  [2004, 'dataMismatchError'],
  [2005, 'userNotFoundError'],
  [2006, 'duplicateEmailError'],
  [2007, 'operatorUserIsBlocked'],
  [3001, 'requestInputValidationError'],
  [3002, 'responseValidationError'],
  [3003, 'socketRequestInputValidationError'],
  [3004, 'socketResponseValidationError'],
  [3005, 'internalServerError'],
  [3006, 'invalidSocketArgumentError'],
  [3007, 'loginFailedError'],
  [3008, 'invalidCredentialsError'],
  [3009, 'invalidTokenError'],
  [3010, 'invalidSessionError'],
  [3011, 'invalidAccessError'],
  [3012, 'userNotExists'],
  [3013, 'invalidAction'],
  [3014, 'sessionAlreadyStarted'],
  [3015, 'sessionNotStarted'],
  [3016, 'somethingWentWrong'],
  [3017, 'loginTokenRequired'],
  [3019, 'invalidVerificationToken'],
  [3020, 'emailNotFound'],
  [3021, 'adminAlreadyExists'],
  [3022, 'invalidDate'],
  [3023, 'invalidDateRange'],
  [3024, 'invalidGameSettingsData'],
  [3025, 'accessDenied'],
  [3026, 'userBlocked'],
  [3027, 'userInactive'],
  [3028, 'cannotDeleteRole'],
  [3029, 'resourceNotFound'],
  [3030, 'ipAlreadyExists'],
  [3031, 'roleAlreadyExists']
])
